export const NAME = 'onlineExamConfig';

const SET_SELECTED_PATH = `SET_SELECTED_PATH_${NAME}`;
const RESET_SELECTED_PATH = `RESET_SELECTED_PATH_${NAME}`;

export const setSelectedPath = (path) => {
	return {
		type: SET_SELECTED_PATH,
		payload: path,
	};
};

export const resetSelectedPath = () => {
	return {
		type: RESET_SELECTED_PATH,
	};
};

const ACTION_MAP = {
	[SET_SELECTED_PATH]: (state, action) => {
		return {
			...state,
			selectedPath: action.payload,
		};
	},
	[RESET_SELECTED_PATH]: (state) => {
		return {
			...state,
			selectedPath: 'INTRODUCTION',
		};
	},
};

const initialState = {
	selectedPath: 'INTRODUCTION',
};

export const reducer = (state = initialState, action) => {
	const actionFunc = ACTION_MAP[action.type];
	return actionFunc ? actionFunc(state, action) : state;
};
